/**
 * WidgetFooter — Navigation bar with back/next buttons and branding.
 */

import { ArrowLeft, ArrowRight } from './icons'

interface WidgetFooterProps {
  canGoBack: boolean
  canGoForward: boolean
  onBack: () => void
  onNext: () => void
  nextLabel?: string
  nextDisabled?: boolean
  showBranding?: boolean
}

export function WidgetFooter({
  canGoBack,
  canGoForward,
  onBack,
  onNext,
  nextLabel = 'Next',
  nextDisabled = false,
  showBranding = true,
}: WidgetFooterProps) {
  return (
    <div className="bw2-footer">
      {showBranding ? (
        <div className="bw2-footer__brand">
          <span>Powered by</span>
          <span className="bw2-footer__brand-accent">Currents</span>
        </div>
      ) : (
        <div />
      )}

      <div className="bw2-footer__actions">
        {canGoBack && (
          <button
            className="bw2-btn bw2-btn--secondary"
            onClick={onBack}
            type="button"
          >
            <ArrowLeft size={12} />
            Back
          </button>
        )}

        {canGoForward && nextLabel && (
          <button
            className="bw2-btn bw2-btn--primary"
            onClick={onNext}
            disabled={nextDisabled}
            type="button"
          >
            {nextLabel}
            <ArrowRight size={12} />
          </button>
        )}
      </div>
    </div>
  )
}
